import {types} from '../../types';

const setGetViewBonusesAction = (payload) => {
    return {
        type: types.bonuses.SET_VIEW_BONUSES,
        payload,
      }
}

const setGetListBonusesAction = (payload) => {
  return {
    type: types.bonuses.SET_LIST,
    payload
  }
}

export {
  setGetViewBonusesAction as SetGetViewBonusesAction,
  setGetListBonusesAction as SetGetListBonusesAction
}
